import React, { useState } from 'react';
import './LoginPage.css';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext.js';
import { getApiBase } from "./backendProbe.js";
import GoogleContinueButton from "./components/GoogleContinueButton.js";

export default function LoginPage() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  return (
    <div className="login-container">
      <a href="#login-title" className="login-skip">
        Skip to sign in
      </a>

      <div className="login-atmosphere" aria-hidden="true">
        <span className="login-wash login-wash--teal" />
        <span className="login-wash login-wash--mist" />
        <span className="login-grain" />
      </div>

      <header className="login-band">
        <div className="login-measure login-band-row">
          <Link to="/" className="login-brand login-brand--nav" aria-label="Zolaid home">
            <span className="login-nav-mark">Zolaid</span>
          </Link>
        </div>
      </header>

      <main
        className="login-form"
        aria-labelledby="login-brand-hero"
        aria-busy={isLoading}
      >
        <div className="login-measure login-panel">
          <div className="login-header">
            <p id="login-brand-hero" className="login-hero-wordmark">
              Zolaid
            </p>
            <h1 id="login-title" className="login-title">
              Sign in
            </h1>
            <p className="login-subtitle">
              Continue with Google to open your chats and work.
            </p>
          </div>

          {error ? (
            <p className="error-message" role="alert">
              {error}
            </p>
          ) : null}

          {isLoading ? (
            <p className="login-status" role="status" aria-live="polite">
              <span className="login-status-dot" aria-hidden="true" />
              Signing you in…
            </p>
          ) : null}

          <div
            className={`social-login${isLoading ? " is-busy" : ""}`}
            role="group"
            aria-label="Continue with Google"
          >
            <GoogleContinueButton
              disabled={isLoading}
              onSuccess={async (credentialResponse) => {
                try {
                  setError('');
                  setIsLoading(true);
                  const token = credentialResponse.credential;
                  const base = getApiBase();
                  const endpoint = base ? `${base}/auth/google` : '/auth/google';
                  const response = await axios.post(endpoint, { token });
                  login(response.data.token, response.data.user);
                  navigate('/chatbot', { replace: true });
                } catch (err) {
                  console.error("Google login failed", err);
                  const msg = err.response?.status === 403 && err.response?.data?.code === 'INVITE_ONLY'
                    ? (err.response.data.message || "This app is invite-only. You don't have access.")
                    : (err.response?.data?.message || 'Google login failed. Check backend URL (getApiBase / runtime-config) and GOOGLE_CLIENT_ID.');
                  setError(msg);
                  setIsLoading(false);
                }
              }}
              onError={() => {
                setIsLoading(false);
                setError("Google login was cancelled or failed.");
              }}
            />
          </div>

          <p className="login-legal">
            By continuing, you agree to our <Link to="/TermsOfService">Terms of Service</Link>{" "}
            <span className="login-legal-tail">and have read our <Link to="/PrivacyPolicy">Privacy Policy</Link>.</span>
          </p>
        </div>
      </main>
    </div>
  );
}
